import { format } from 'date-fns';

const NBSP = String.fromCharCode(160);
const DBNBSP = String.fromCharCode(160, 160);

function applyMonthAbbreviations(str) {
    return str
        .replace('Jun', 'June')
        .replace('Jul', 'July')
        .replace('Sep', 'Sept');
}

export default function formatDateRange(startDate, endDate = null) {
    if (!endDate) {
        const day = format(startDate, 'EEE');
        const month = applyMonthAbbreviations(format(startDate, 'MMM'));
        const dom = format(startDate, 'd');
        const year = format(startDate, 'yyyy');
        const time = startDate.getMinutes()
            ? format(startDate, 'h:mmaa')
            : format(startDate, 'haa');

        return day + DBNBSP + month + NBSP + dom + ',' + NBSP + year + DBNBSP + time;
    }

    const startMonth = applyMonthAbbreviations(format(startDate, 'MMM'));
    const endMonth = applyMonthAbbreviations(format(endDate, 'MMM'));
    const startDay = format(startDate, 'd');
    const endDay = format(endDate, 'd');
    const startYear = format(startDate, 'yyyy');
    const endYear = format(endDate, 'yyyy');

    if (format(startDate, 'yyyyMMdd') === format(endDate, 'yyyyMMdd')) {
        return startMonth + NBSP + startDay + ',' + NBSP + startYear;
    }

    if (startYear !== endYear) {
        return startMonth + NBSP + startDay + ',' + NBSP + startYear + NBSP + '&' + NBSP + endMonth + NBSP + endDay + ',' + NBSP + endYear;
    }

    if (format(startDate, 'yyyyMM') === format(endDate, 'yyyyMM')) {
        return startMonth + NBSP + startDay + '–' + endDay + ',' + NBSP + startYear;
    }

    return startMonth + NBSP + startDay + '–' + endMonth + NBSP + endDay + ',' + NBSP + startYear;
}
